import React, { useRef, useState, useEffect, useCallback } from "react";
import {
  Table,
  Form,
  Menu,
  Icon,
  Button,
  Loader,
  Header,
  Modal,
  Radio,
  Checkbox,
  Segment,
  Dropdown,
  Input,
  Item,
} from "semantic-ui-react";
import {
  Container,
  Title,
  Field,
  Label,
  InputFile,
  InputText,
  InputLabel,
} from "../../../../../pages/Admin/Empresas/criarEmpresas/styled";
import { producaov2 as api } from "../../../../../services/apis";
import swal from "sweetalert";

const Gerentes = (props) => {
  const [aluno, setAluno] = useState("");
  const [alunoSearch, setAlunoSearch] = useState("");
  const [alunosOptions, setAlunosOptions] = useState([]);
  const gerentes = useRef({
    id: "",
    nome: "",
    email: "",
  });

  const gestores = useRef(props.valor);
  const [view, setView] = useState([]);
  const [deletar, setDeletar] = useState(props.del);
  const [criar, setCriar] = useState(props.criar);
  const [open, setOpen] = useState(false);
  const [cursoValue, setCursoValue] = useState(props.cursos);

  useEffect(() => {
    loadView();
  }, []);

  const loadView = () => {
    console.log(gestores.current);
    if (gestores.current.length != 0) {
      const newView = gestores.current.map((gerente) => ({
        ...view,

        empresa: props.id,
        nome: gerente.pessoa.nome,
        email: gerente.pessoa.email,
        id_pessoa: gerente.pessoa.id,
        id: gerente.id,
      }));
      setView(newView);
    }
  };

  const addTabela = useCallback(() => {
    const value = [
      ...view,
      {
        id: gerentes.current.id,
        nome: gerentes.current.nome,
        email: gerentes.current.email,
      },
    ];
    const valueCriar = [
      ...criar,
      {
        empresa: props.id,
        id: gerentes.current.id,
        nome: gerentes.current.nome,
        email: gerentes.current.email,
      },
    ];
    setView([
      ...view,
      {
        id: gerentes.current.id,
        nome: gerentes.current.nome,
        email: gerentes.current.email,
      },
    ]);
    setCriar(valueCriar);
    handleValueCriar(value);
    handleValue(value);
    handleValueCriar(value);
  }, [view]);

  const deleteTabela = useCallback(
    (id) => {
      const newGerente = view.filter((gerente) => gerente.id !== id);
      const newDelete = view.filter((gerente) => gerente.id === id);
      if (newDelete[0].id == null) {
        const newCriar = criar.filter((gerente) => gerente.id !== id);
        setCriar(newCriar);
        handleValueCriar(newCriar);
      } else {
        const newDel = [...deletar, ...newDelete];
        setDeletar(newDel);
        handleValueDel(newDel);
      }
      setView(newGerente);
      handleValue(newGerente);
    },
    [view]
  );

  const handleAlunoChange = useCallback((e, { options, value }) => {
    gerentes.current["id"] = value.id;
    gerentes.current["nome"] = value.nome;
    gerentes.current["email"] = value.email;
    const text = options.find((option) => option.value.id === value.id).text;

    setAluno(value);
    setAlunoSearch(text);
  }, []);

  const handleAlunoSearchChange = useCallback((e) => {
    const search = e.target.value;
    api
      .get(`alunos?search=${search}&limit=15`)
      .then((res) => {
        if (res.data.length > 0) {
          const options = res.data.map((pessoa, index) => ({
            key: index,
            nome: pessoa.nome,
            text: `(nome:${pessoa.nome}) (email:${pessoa.email}) [ID: ${pessoa.id}]`,
            value: {
              nome: pessoa.nome,
              email: pessoa.email,
              id: pessoa.id,
            },
          }));
          console.log(options);
          setAlunosOptions(options);
          return;
        }
        setAlunosOptions([]);
      })
      .catch((err) => console.error(err));
    setAlunoSearch(search);
  });

  const handleValue = (valor) => {
    props.handleGerentes(valor);
  };

  const handleValueCriar = (valor) => {
    props.handleGerentesCriar(valor);
  };

  const handleValueDel = (valor) => {
    props.handleGerentesDel(valor);
  };

  return (
    <>
      <Modal
        closeIcon
        open={open}
        trigger={
          <Button>
            <Icon name="add" />
            Adicionar Gerente
          </Button>
        }
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
      >
        <Header content="Plano Empresa" />
        <Modal.Content>
          <div>
            <Label>Curso:</Label>
            <Dropdown
              placeholder="Busque pelo ID, Nome ou E-mail do aluno"
              fluid
              search
              selection
              options={alunosOptions}
              onChange={handleAlunoChange}
              searchQuery={alunoSearch}
              onSearchChange={handleAlunoSearchChange}
              value={aluno}
            />
          </div>
        </Modal.Content>
        <Modal.Actions>
          <Button
            color="green"
            onClick={() => {
              setOpen(false);
              addTabela();
            }}
          >
            <Icon name="checkmark" /> confirmar
          </Button>
          <Button
            color="red"
            onClick={() => {
              setOpen(false);
            }}
          >
            <Icon name="remove" /> cancelar
          </Button>
        </Modal.Actions>
      </Modal>

      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>Usuario</Table.HeaderCell>
            <Table.HeaderCell>Email</Table.HeaderCell>
            <Table.HeaderCell>Ações</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {view.map((gerente) => (
            <Table.Row>
              <Table.Cell>{gerente.nome}</Table.Cell>
              <Table.Cell>{gerente.email}</Table.Cell>
              <Table.Cell>
                <>
                  <Button
                    icon="trash icon"
                    info="delete"
                    onClick={() => {
                      deleteTabela(gerente.id);
                    }}
                  ></Button>
                </>
              </Table.Cell>
            </Table.Row>
          ))}
        </Table.Body>
      </Table>
    </>
  );
};

export default Gerentes;
